// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import AppLayout, { AppLayoutProps } from '@cloudscape-design/components/app-layout';
import { createPortal } from 'react-dom';
import TopNavigation, { TopNavigationProps } from '@cloudscape-design/components/top-navigation';
// @ts-ignore: TS2614
import type { Item } from '@cloudscape-design/components/top-navigation';
import Badge from '@cloudscape-design/components/badge';
import SideNavigation, { SideNavigationProps } from '@cloudscape-design/components/side-navigation';
import { useGlobalState } from '../context/GlobalStateContext';
import { AppLayoutToolbar, Box, ColumnLayout, Icon, LiveRegion, SpaceBetween } from '@cloudscape-design/components';
import { LoadingOverlay } from '../commons/LoadingOverlay'; // Example corrected path

interface CustomAppLayoutProps extends AppLayoutProps {
  // initialHelpPanelPage: string; // Removed this line
}

interface DemoHeaderPortalProps {
  children: ReactNode;
}

const DemoHeaderPortal = ({ children }: DemoHeaderPortalProps) => {
  const domNode = document.querySelector('#h')!;
  return createPortal(children, domNode);
};

interface CustomSection extends SideNavigationProps.Section {
  section?: string;
  items: readonly SideNavigationProps.Item[]; // Match the exact type (required + readonly)
}

function sectionHasActiveLink(section: any, hash: string): boolean {
  if (!section) return false;
  const hashPath = hash.split('?')[0];
  if (section.section) {
    return hashPath.startsWith(section.section);
  }
  if (section.items) {
    return section.items.some((item: any) => {
      if (item.type === 'link') {
        return item.href === hashPath;
      } else if (item.type === 'section') {
        return sectionHasActiveLink(item, hash);
      }
      return false;
    });
  }
  return false;
}

/*
const clientId = "AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc.apps.googleusercontent.com";
function GoogleInit() {
  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: clientId,
        scope: "email profile",
      });
    }

    gapi.load('client:auth2', start);
  }, []);

  return null;
}
*/

export function CustomAppLayout({ ...props }: CustomAppLayoutProps) {


  const { pendingAuth, setPendingAuth } = useGlobalState();
  const { pendingGuests, setPendingGuests } = useGlobalState();
  const { guests, setGuests } = useGlobalState();
  const { notifications, setNotifications } = useGlobalState();

  const { invoices, setInvoices } = useGlobalState();
  const { invoicesExpired, setInvoicesExpired } = useGlobalState();
  const { propiedad } = useGlobalState();
  const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState();
  const { showPropertiesSelector, setShowPropertiesSelector } = useGlobalState();
  const { currentVersion, setCurrentVersion } = useGlobalState();
  const { loading } = useGlobalState();
  const { gData, setGData } = useGlobalState();
  const { menu, setMenu } = useGlobalState();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { topNotificationsBadge } = useGlobalState();
  const { displayName } = useGlobalState();

  //const { state, actions, appLayoutRef } = useStore();
  const [navigationOpen, setNavigationOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [currentHash, setCurrentHash] = useState(window.location.hash);
  const [showNavigation, setShowNavigation] = useState(true);
  const [showAdminUsers, setShowAdminUsers] = useState(false);
  const [showTools, setShowTools] = useState(false);
  const [propText, setPropText] = useState("");
  setTimeout(function () {
    setCurrentVersion(133)
  }, 0)
  const profileActions = [
    {
      id: 'preferences', text: 'Preferencias',

      items: [
        {
          id: 'password',
          text: 'Modificar contraseña',
          href: '#admin/password',
        },
        {
          id: 'update',
          text: (
            <SpaceBetween direction="horizontal" size="s">
              <Box>Versión {currentVersion}</Box>
              {serverVersion > currentVersion && (
                <Badge color="red">
                  <Icon name="upload" /> {serverVersion}
                </Badge>
              )}
            </SpaceBetween>
          ),
          href: '/',
        },
      ]
    },
    {
      id: 'support-group',
      text: 'Administración',

      items: [
        showAdminUsers &&
        {
          id: 'users',
          text: 'Usuarios',
          href: '#admin/users',
        },
        showPropertiesSelector > 0 && { //  
          id: 'support-group',
          type: "button",
          text: "Propiedades",
          href: '#admin/properties?returnURL=' + (window.location.hash || '#home'),
          badge: true
        },

      ].filter(Boolean),

    },
    { id: 'signout', text: 'Cerrar Sesión', href: '#user/logoff' },
  ];
  useEffect(() => {

  }, [showPropertiesSelector]); // Removed this useEffect
  //console.log("showPropertiesSelector:" + showPropertiesSelector)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setNavigationOpen(!isMobile);
  }, [isMobile]);

  useEffect(() => {
    /*
        if (gData && gData.properties && gData.properties.length > 1) {
          setPropText(`Propiedades (${gData.properties.length})`)
          //console.log((`Propiedades (${gData.properties.length})`))
        } else {
          setPropText("Propiedades")
        }
          */
    const onHashChange = () => setCurrentHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // remove '#'
      setShowNavigation(!hash.startsWith('user/') && !hash.startsWith('samples/'));
    };

    handleHashChange(); // run initially
    window.addEventListener('hashchange', handleHashChange);

    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const [navItems, setNavItems] = useState<SideNavigationProps.Item[]>([]);
  const handleExpand = (indexToExpand: number) => {
    //console.log(indexToExpand)
  }

  useEffect(() => {
    //console.log(menu)
    if (gData && gData.adminFunciones && gData.adminFunciones.notifications) {
      setShowAdminUsers(gData.adminFunciones.notifications.includes('INTERNAL.USERS'))
    } else {
      setShowAdminUsers(false)
    }
  }, [gData]); //pendingAuth, invoicesExpired

  useEffect(() => {
    //console.log(menu)
    if (menu) {

      const fetchNav = async () => {
        //const response = await fetch('https://api2.llavemovil.com/routing/2024-08/test.aspx');
        //const data = await response.json();
        const data = menu;
        if (Object.keys(data).length > 0) {
          // Map variable names to actual values
          const badgeData: Record<string, number> = {
            pendingAuth,
            invoicesExpired,
            pendingGuests,
            guests,
            notifications,
            // Add any other badge variables here
          };
          let index = -1;
          const processedNav = data.map((item: any) => {
            index++;
            if (item.type === 'section') {
              // Use the new function that checks if hash starts with item.section
              const isActive = sectionHasActiveLink(item, window.location.hash);

              return {
                ...item,
                defaultExpanded: isActive,
                onChange: handleExpand(index),
                items: item.items.map((subItem: any) => {
                  if (subItem.badge && subItem.badgeVariable && badgeData[subItem.badgeVariable] > 0) {
                    return {
                      ...subItem,
                      info: <Badge color={subItem.badgeColor || 'blue'}>{badgeData[subItem.badgeVariable]}</Badge>,
                    };
                  }
                  return subItem;
                }),
              };
            }
            return item;
          });
          setNavItems(processedNav);
        }
      };

      //console.log(menu)
      fetchNav();
    }

    const handleResize = () => {
      if (window.innerWidth < 1280) {
        setNavigationOpen(false);
      }
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [menu]); //pendingAuth, invoicesExpired
  const notificationItems: Item[] = [
    invoicesExpired > 0 && {
      id: 'invoice',
      text: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <span>Facturación</span>
          <Badge color='red'>{invoicesExpired}</Badge>
        </div>
      ),
      href: '#invoices/pendings',
      iconName: "status-warning",
    },
    pendingAuth > 0 && {
      id: 'auth',
      text: (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <span>Solicitudes</span>
          <Badge>{pendingAuth}</Badge>
        </div>
      ),
      href: '#users/authorize',
      iconName: "lock-private",
    },
  ].filter(Boolean) as Item[];
  const navRef = useRef(null);
  return (
    <>

      <DemoHeaderPortal>
        <TopNavigation
          identity={{
            href: '#home',
            title: propiedad,
            logo: {
              src: "/resources/logo.llavemovil3.png",
              alt: "Service"
            }
          }}
          utilities={ 
            idPropiedad != 0 ?
              [
                { type: 'button', text: `v${currentVersion}` },
                ...(notificationItems.length > 0
                  ? [{
                    type: 'menu-dropdown',
                    iconName: 'notification',
                    items: notificationItems,
                    badge: topNotificationsBadge === 1,
                  } as const] // 👈 fix here
                  : []),
                //{ type: 'button', iconName: 'settings', title: 'Settings', ariaLabel: 'Settings' },

                {
                  type: 'menu-dropdown',
                  text: displayName,
                  iconName: 'user-profile',
                  items: profileActions,
                  onItemClick: (event) => {
                    if (event.detail.id === 'signout') {
                      window.location.href = '#user/logout';
                    }
                  },
                },

              ] : []}
        />

      </DemoHeaderPortal>
      <AppLayoutToolbar
        contentType='form'
        navigation={showNavigation ? <div ref={navRef}><SideNavigation activeHref={currentHash} items={navItems} /></div> : undefined}
        navigationOpen={showNavigation && navigationOpen}
        onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
        splitPanelPreferences={{
          position: 'side',
        }
        }
        onSplitPanelPreferencesChange={() => { }}
        {...props}
      />
      {loading && <LoadingOverlay />}
    </>
  );
}